import tileSelect from './tileSelect.json';
import gauge from './gauge.json';
import table from './table.json';
import healthCountsAndsInstances from './heathCountsAndInstances.json';
import Dropdown from './Dropdown.json';
import helpText from './helpText.json';

export default [tileSelect, gauge, table, healthCountsAndsInstances, Dropdown, helpText];
